import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { memo } from 'react';
import { RemoveAssignmentsButton, removeAssignmentCssStyle, } from '../../../elements/RemoveAssignmentsButton';
import { HighlightEventSource } from '../../../highlight';
const columnStyle = {
    padding: 0,
    textAlign: 'center',
    verticalAlign: 'middle',
};
function getStyle(flag, isCompletelyAssigned) {
    if (flag) {
        return {
            color: 'red',
            fontWeight: 'bold',
        };
    }
    else if (isCompletelyAssigned) {
        return { color: 'green', fontWeight: 'bold' };
    }
    else {
        return { color: 'black', fontWeight: 'normal' };
    }
}
function RangeAssignmentsColumn({ row, assignment, highlight, onLink, onUnlink, rowSpanTags, onHover, highlightData, }) {
    const diaIDs = row.diaIDs || [];
    const flag = assignment.isActive ||
        assignment.isOver ||
        (highlight.isActive &&
            highlightData.highlight.sourceData?.type !== HighlightEventSource.SIGNAL);
    const isCompletelyAssigned = Math.round(row.integration) === row?.nbAtoms;
    let totalNumberOfAtoms = row?.nbAtoms || 0;
    for (const signal of row?.signals || []) {
        totalNumberOfAtoms += signal?.nbAtoms || 0;
    }
    return (_jsx("td", { ...rowSpanTags, style: {
            ...columnStyle,
            ...rowSpanTags.style,
        }, ...onHover, onClick: (e) => onLink?.(e, assignment), css: !assignment.isActive && removeAssignmentCssStyle, children: (totalNumberOfAtoms > 0 || assignment.isActive) && (_jsxs(_Fragment, { children: [totalNumberOfAtoms, " ", ' ( ', _jsx("span", { style: getStyle(flag, isCompletelyAssigned), children: diaIDs?.length || 0 }), ' ) ', _jsx(RemoveAssignmentsButton, { onClick: (e) => onUnlink?.(e, true) })] })) }));
}
export default memo(RangeAssignmentsColumn);
